import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, Gift, ChefHat } from 'lucide-react';

export default function ArtikelRamadanIftarRezepte() {
  return (
    <main className="pt-20 md:pt-24 bg-[#FDFCF8]">
      <section className="py-16 md:py-24 bg-[#4A5D4F]">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <Link to="/ratgeber" className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-8 transition-colors"><ArrowLeft className="w-4 h-4" />Alle Ratgeber</Link>
          <div className="flex items-center gap-2 text-[#D4C5A9] text-sm mb-4"><Calendar className="w-4 h-4" /><span>Februar 2026</span></div>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium text-white mb-6 leading-tight">Ramadan Iftar Rezepte: Traditionell und Modern</h1>
          <p className="text-lg text-white/80 leading-relaxed">Die besten Iftar-Rezepte für den Ramadan – von klassischen Suppen bis zu modernen Gerichten, die die ganze Familie begeistern.</p>
        </div>
      </section>
      <article className="py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-12 prose prose-lg max-w-none">
          <p className="text-xl text-[#2C332E] leading-relaxed mb-8">Das Iftar – das Fastenbrechen bei Sonnenuntergang – ist der Höhepunkt jedes Ramadan-Tages. Eine ausgewogene, schmackhafte Mahlzeit gibt Kraft und bringt die Familie zusammen. Wir haben die beliebtesten Iftar-Rezepte gesammelt – von traditionell bis modern.</p>

          <section className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-[#D4C5A9]/30 flex items-center justify-center"><ChefHat className="w-6 h-6 text-[#4A5D4F]" /></div>
              <h2 className="font-serif text-2xl font-medium text-[#2C332E]">Suppen & Vorspeisen</h2>
            </div>
            <p className="text-[#4B5563] mb-4">Das Iftar beginnt traditionell mit Datteln und Wasser, gefolgt von einer warmen Suppe.</p>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Harira – Marokkanische Ramadan-Suppe</h4>
                <p className="text-sm text-[#4B5563]">Der Klassiker unter den Iftar-Suppen: Kichererbsen, Linsen, Tomaten und Koriander. Sättigend, nährstoffreich und wärmend. In Marokko undenkbar ohne!</p>
                <p className="text-xs text-[#4A5D4F] mt-2">Zubereitungszeit: ca. 60 Min. | Für 6 Personen</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Shorba – Arabische Linsensuppe</h4>
                <p className="text-sm text-[#4B5563]">Rote Linsen mit Kreuzkümmel, Kurkuma und Zitrone. Schnell zubereitet und perfekt für den empfindlichen Magen nach einem Fastentag.</p>
                <p className="text-xs text-[#4A5D4F] mt-2">Zubereitungszeit: ca. 30 Min. | Für 4 Personen</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Fattoush-Salat</h4>
                <p className="text-sm text-[#4B5563]">Frischer Salat mit geröstetem Fladenbrot, Sumach und einem Zitronendressing. Leicht und erfrischend als Beilage oder Vorspeise.</p>
                <p className="text-xs text-[#4A5D4F] mt-2">Zubereitungszeit: ca. 15 Min. | Für 4 Personen</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Hauptgerichte</h2>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Chicken Biryani</h4>
                <p className="text-sm text-[#4B5563]">Gewürzreis mit zartem Hähnchen, Safran und Rosenwasser. Ein Festmahl aus der südasiatischen Küche, das bei vielen muslimischen Familien in Deutschland beliebt ist.</p>
                <p className="text-xs text-[#4A5D4F] mt-2">Zubereitungszeit: ca. 90 Min. | Für 6 Personen</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Kabsa – Saudisches Reisgericht</h4>
                <p className="text-sm text-[#4B5563]">Aromatischer Reis mit Lamm, Tomaten und einer einzigartigen Gewürzmischung. Wird traditionell auf einer großen Platte in der Mitte serviert.</p>
                <p className="text-xs text-[#4A5D4F] mt-2">Zubereitungszeit: ca. 120 Min. | Für 8 Personen</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Kousa Mahshi – Gefüllte Zucchini</h4>
                <p className="text-sm text-[#4B5563]">Ausgehöhlte Zucchini gefüllt mit Reis, Hackfleisch und Gewürzen, in Tomatensoße geschmort. Ein levantinischer Klassiker, der auch Kindern schmeckt.</p>
                <p className="text-xs text-[#4A5D4F] mt-2">Zubereitungszeit: ca. 90 Min. | Für 6 Personen</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Doner-Bowl (modern)</h4>
                <p className="text-sm text-[#4B5563]">Eine moderne Variante: Halal-Dönerfleisch auf Reis mit Hummus, Salat und Joghurtsoße. Schnell, lecker und bei der jüngeren Generation beliebt.</p>
                <p className="text-xs text-[#4A5D4F] mt-2">Zubereitungszeit: ca. 30 Min. | Für 4 Personen</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Desserts & Süßes</h2>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Basbousa</h4>
                <p className="text-sm text-[#4B5563]">Saftiger Grießkuchen mit Kokosflocken und Zuckersirup. Einfach zu backen und perfekt für große Runden – jedes Stück ist ein Genuss.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Qatayef</h4>
                <p className="text-sm text-[#4B5563]">Ramadan-Pfannkuchen gefüllt mit Käse oder Nüssen, frittiert und in Sirup getaucht. DAS Ramadan-Dessert schlechthin!</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">Dattel-Energie-Bällchen</h4>
                <p className="text-sm text-[#4B5563]">Datteln, Nüsse, Kokos und Kakao – im Mixer zerkleinert und zu Kugeln geformt. Gesund, energiereich und perfekt für Suhoor.</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Tipps für die Ramadan-Küche</h2>
            <div className="bg-[#4A5D4F]/10 rounded-xl p-6">
              <ul className="text-[#4B5563] space-y-3">
                <li><strong>Meal Prep:</strong> Am Wochenende für mehrere Tage vorkochen spart Zeit und Stress</li>
                <li><strong>Hydration:</strong> Zwischen Iftar und Suhoor mindestens 2 Liter Wasser trinken</li>
                <li><strong>Langsam essen:</strong> Nach dem Fasten den Magen nicht überlasten – mit Datteln und Suppe beginnen</li>
                <li><strong>Suhoor nicht auslassen:</strong> Eine nährstoffreiche Mahlzeit vor dem Fasten gibt Energie für den Tag</li>
                <li><strong>Gemeinsam kochen:</strong> Kinder einbeziehen – sie lernen Traditionen und haben Spaß</li>
              </ul>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Fazit</h2>
            <p className="text-[#4B5563] leading-relaxed mb-4">Das Iftar ist mehr als nur eine Mahlzeit – es ist ein tägliches kleines Fest. Ob du traditionelle Rezepte deiner Familie kochst oder neue ausprobierst: Die Hauptsache ist, dass ihr zusammenkommt und die Segnungen des Ramadan teilt.</p>
            <p className="text-xl text-[#4A5D4F] font-medium">Ramadan Kareem!</p>
          </section>

          <div className="bg-[#F5F5F0] rounded-2xl p-6 mb-8">
            <h3 className="font-serif text-lg font-medium text-[#2C332E] mb-4">Weitere Artikel</h3>
            <ul className="space-y-2">
              <li><Link to="/ratgeber/eid-fruehstueck-ideen" className="text-[#4A5D4F] hover:underline">→ Eid Frühstück Ideen</Link></li>
              <li><Link to="/ratgeber/ramadan-geschenke" className="text-[#4A5D4F] hover:underline">→ Ramadan Geschenke Guide</Link></li>
            </ul>
          </div>

          <div className="bg-[#4A5D4F] rounded-2xl p-8 text-center">
            <h3 className="font-serif text-2xl font-medium text-white mb-4">Geschenke entdecken</h3>
            <Link to="/geschenke" className="inline-flex items-center gap-2 bg-white text-[#4A5D4F] px-8 py-3 rounded-full font-medium hover:bg-[#D4C5A9] transition-colors">Jetzt stöbern<Gift className="w-5 h-5" /></Link>
          </div>
        </div>
      </article>
    </main>
  );
}
